export function AppDownloadSection({ type = 'Buy' }) {
	const contentMap = {
    Buy: {
      title: 'Buy digital gold instantly using the JustGold app',
      image: '/buy/step1.svg',
    },
    Sell: {
      title: 'Sell gold easily through the JustGold app',
      image: '/sell/step1.svg',
    },
    Delivery: {
      title: 'Order gold easily through the JustGold app',
      image: '/delivery/step3.svg',
    },
  };

  const { title, image } = contentMap[type] || contentMap.Buy;
	return (
		<section className='py-10 bg-[#F1F5FA]'>
			<div className='max-w-7xl mx-auto'>
				<div className='grid lg:grid-cols-2 gap-6 lg:gap-8 items-center'>
					{/* Left Image */}
					<div className='flex justify-center lg:justify-center'>
						<img
							 src={image}
                             alt={type}
							className='w-[280px] sm:w-[320px] lg:w-[360px] h-auto'
						/>
					</div>

					{/* Right Content */}
					<div>
						<h2 className='text-2xl sm:text-3xl md:text-4xl font-semibold text-[#192839] leading-tight mb-4'>
							{title}
						</h2>

						<p className='text-sm sm:text-base md:text-lg text-[#40566d] mb-6'>
							JustGold lets you buy, sell, and own certified Track prices in
							real time, and{' '}
							<a href='#' className='text-blue-800 underline'>
								choose storage
							</a>{' '}
							or{' '}
							<a href='#' className='text-blue-800 underline'>
								doorstep delivery
							</a>
							. Download the JustGold app on{' '}
							<a href='#' className='text-blue-800 underline'>
								Android
							</a>{' '}
							or{' '}
							<a href='#' className='text-blue-800 underline'>
								iOS store
							</a>{' '}
							and start saving today.
						</p>

						<p className='text-sm sm:text-base md:text-lg text-[#40566d]'>
							The platform provides{' '}
							<a href='#' className='text-blue-800 underline'>
								live gold prices
							</a>
							, secure digital storage, and insured delivery across the UAE.
						</p>

						{/* Download Buttons */}
						<div className='flex justify-center md:justify-normal w-full flex-row gap-4 sm:gap-6 md:mt-6'>
							<a
								href='https://play.google.com/store/apps/details?id=com.justgold'
								target='_blank'
								rel='noopener noreferrer'
								onClick={() => window.trackAppDownload('android')}
								className='transform hover:scale-105 transition-transform duration-300'
							>
								<img
									src='/googleplay.svg'
									alt='Google Play Store'
									width={160}
									height={50}
									className='w-36 sm:w-40 h-auto'
								/>
							</a>
							<a
								href='https://apps.apple.com/in/app/just-gold/id6744900430'
								target='_blank'
								rel='noopener noreferrer'
								onClick={() => window.trackAppDownload('ios')}
								className='transform hover:scale-105 transition-transform duration-300'
							>
								<img
									src='/app-store.svg'
									alt='Apple App Store'
									width={160}
									height={50}
									className='w-36 sm:w-40 h-auto'
								/>
							</a>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
